// extracted by mini-css-extract-plugin
export default {"Container":"reviews_Container__WRMLa","PeopleReviews":"reviews_PeopleReviews__iGyEr","AverageReviews":"reviews_AverageReviews__aR8h9"};